import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    protoOf($).f2f = execute;
    initMetadataForCompanion($, VOID, [ActionPipe()], [2]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function *execute(dispatcher, action, $completion) {
  return yield* action.g2f(dispatcher, $completion);
}
var ActionPipeClass;
function ActionPipe() {
  if (ActionPipeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ActionPipe', VOID, VOID, VOID, [2]);
    ActionPipeClass = $;
  }
  return ActionPipeClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ActionPipe as ActionPipe2nmxwvx2ocjhz,
  Companion_instance as Companion_instancercv49ep9xa3t,
  execute as executesihtib9b5qrj,
};
//endregion

//# sourceMappingURL=ActionPipe.mjs.map
